<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 22C2.871 22 2.741 21.976 2.617 21.924C2.244 21.77 2 21.404 2 21V5C2 3.346 3.346 2 5 2H19C20.654 2 22 3.346 22 5V15C22 16.654 20.654 18 19 18H7.414L3.707 21.707C3.516 21.898 3.26 22 3 22ZM5 4C4.449 4 4 4.449 4 5V18.586L6.293 16.293C6.48 16.105 6.735 16 7 16H19C19.552 16 20 15.552 20 15V5C20 4.449 19.552 4 19 4H5Z" fill="currentColor"/>
        <path d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z" fill="currentColor"/>
        <path d="M7 8C7 7.44772 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: "CommentFilled"
};
</script>
